module.exports = __webpack_public_path__ + "static/media/CTLA_4-178w.c1fa6124.jpg";